//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
import { omit, get, find } from 'lodash';
import { syncAssignmentStatusToFirestore } from 'utils/methods/assignmentStatusFirestore';
//  -- Actions ------------------------
import * as ClassActivityActions from './actions';
import * as ClassQuizAction from '../classQuizzes/actions';
import * as ClassGameAction from '../one_game/actions';
import { logToSentry } from "utils/networkErrorUtils";
// import { getDateTime } from 'utils/methods/math';
import moment from 'moment';
import { setLoadQuizAndClassActivity } from 'store/loadClassActivityAndQuiz/action';
import { handleListClassQuizzes } from 'store/classQuizzes/thunks';

const patchCurrentClassDueInClassRows = (classes, rootDue, classId) => {
    if (!classes?.length || !rootDue || !classId) {
        return classes;
    }
    return classes.map((cls) => {
        const users = cls.users ? cls.users : [];
        if (String(cls.id) !== String(classId)) {
            return { ...cls, users };
        }
        return {
            ...cls,
            dueDate: rootDue,
            diff: cls.diff ? { ...cls.diff, dueDateDif: rootDue } : cls.diff,
            users,
        };
    });
};

const alignActivityPayloadCurrentClassDueDate = (dataClassActivity, rootDue, classId) => {
    if (!rootDue || !classId) return;
    if (dataClassActivity.classes?.length) {
        dataClassActivity.classes = patchCurrentClassDueInClassRows(
            dataClassActivity.classes,
            rootDue,
            classId
        );
    }
    if (Array.isArray(dataClassActivity.selectedAssignments)) {
        dataClassActivity.selectedAssignments = dataClassActivity.selectedAssignments.map((sa) => {
            if (!sa?.classes?.length) return sa;
            return {
                ...sa,
                classes: patchCurrentClassDueInClassRows(sa.classes, rootDue, classId),
            };
        });
    }
};

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create class activity ----------
export const handleCreateClassActivityGoogle = (data, googleId) => async (dispatch) => {
    await dispatch(ClassActivityActions.createClassActivity());

    try {
        data.scheduleAt = data.scheduleAt && moment(data.scheduleAt).isValid() ? data.scheduleAt : moment().toString();
        let dataClassActivity = omit(data, ['studentsSelected', 'dueDateDif', 'retakesDif', 'multipleAssignments']);
        alignActivityPayloadCurrentClassDueDate(dataClassActivity, data.dueDate, data.classId);
        if (dataClassActivity.classes && dataClassActivity.classes.length > 0) {
            dataClassActivity.classes = dataClassActivity.classes.map(cls => ({ ...cls, users: cls.users ? cls.users : [] }));
        }
        if (Array.isArray(dataClassActivity.selectedAssignments)) {
            dataClassActivity.selectedAssignments = dataClassActivity.selectedAssignments.map((sa) => {
                if (!sa?.classes?.length) return sa;
                return {
                    ...sa,
                    classes: sa.classes.map((cls) => ({ ...cls, users: cls.users ? cls.users : [] })),
                };
            });
        }
        const diffActivity = [];
        let dataSS = data.studentsSelected;
        if (Array.isArray(dataSS)) {
            dataSS.forEach(student => {
                diffActivity.push({
                    classId: data.classId,
                    type: 'activity',
                    exerciseId: data.activityId,
                    userId: student.studentId,
                    dueDate: data.dueDateDif ? data.dueDateDif : data.dueDate,
                    retakes: data.retakesDif ? data.retakesDif : data.retakes,
                    displayName: data.displayName,
                    scheduleAt: data.scheduleAtDiff ? data.scheduleAtDiff : data.scheduleAt,
                    lateDate: data.lateDate,
                });
            });
        }
        const clsAct = await apis.post('classActivitiesRDS', `/classActivitiesMultipleDiff`, {
            body: { activity: dataClassActivity, diff: diffActivity, selectedAssignments: data.selectedAssignments, googleId: googleId }
        });
        if (clsAct && !clsAct.error) {
            const update = {
                ...clsAct.activity.filter(act => act.classId == data.classId)[0],
                diff:get(clsAct,"diff",[]),
                data: omit(dataClassActivity, ['activityId', 'classId', 'dueData']),
                selectedAssignments: data.selectedAssignments
            };
            await dispatch(ClassActivityActions.createClassActivitySuccess(update));
        }
         dispatch(handleListClassActivities(data.classId));
         dispatch(handleListClassQuizzes(data.classId));
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating class activity',
                error,
                module: 'CLASS_ACTIVITIES',
                operation: 'CREATE_CLASS_ACTIVITY'
            });
        }
        await dispatch(ClassActivityActions.createClassActivityFail(error));
    }
};

export const handleCreateClassActivitySchoology = (data, schoologyid) => async (dispatch) => {
    await dispatch(ClassActivityActions.createClassActivity());

    try {
        data.scheduleAt = data.scheduleAt && moment(data.scheduleAt).isValid() ? data.scheduleAt : moment().toString();
        let dataClassActivity = omit(data, ['studentsSelected', 'dueDateDif', 'retakesDif', 'multipleAssignments']);
        alignActivityPayloadCurrentClassDueDate(dataClassActivity, data.dueDate, data.classId);
        if (dataClassActivity.classes && dataClassActivity.classes.length > 0) {
            dataClassActivity.classes = dataClassActivity.classes.map(cls => ({ ...cls, users: cls.users ? cls.users : [] }));
        }
        if (Array.isArray(dataClassActivity.selectedAssignments)) {
            dataClassActivity.selectedAssignments = dataClassActivity.selectedAssignments.map((sa) => {
                if (!sa?.classes?.length) return sa;
                return {
                    ...sa,
                    classes: sa.classes.map((cls) => ({ ...cls, users: cls.users ? cls.users : [] })),
                };
            });
        }
        const diffActivity = [];
        let dataSS = data.studentsSelected;
        if (Array.isArray(dataSS)) {
            dataSS.forEach(student => {
                diffActivity.push({
                    classId: data.classId,
                    type: 'activity',
                    exerciseId: data.activityId,
                    userId: student.studentId,
                    dueDate: data.dueDateDif ? data.dueDateDif : data.dueDate,
                    retakes: data.retakesDif ? data.retakesDif : data.retakes,
                    displayName: data.displayName,
                    scheduleAt: data.scheduleAtDiff ? data.scheduleAtDiff : data.scheduleAt,
                    lateDate: data.lateDate,
                });
            });
        }
        const timezoneName = typeof Intl !== 'undefined' && Intl.DateTimeFormat
            ? Intl.DateTimeFormat().resolvedOptions().timeZone
            : undefined;
        const clsAct = await apis.post('classActivitiesRDS', `/classActivitiesMultipleSchoology`, {
            body: { activity: dataClassActivity, diff: diffActivity, selectedAssignments: data.selectedAssignments, schoologyid: schoologyid, timezone_name: timezoneName }
        });
        if (clsAct && !clsAct.error) {
            const update = {
                ...clsAct.activity.filter(act => act.classId == data.classId)[0],
                diff:get(clsAct,"diff",[]),
                data: omit(dataClassActivity, ['activityId', 'classId', 'dueData']),
                selectedAssignments: data.selectedAssignments
            };
            await dispatch(ClassActivityActions.createClassActivitySuccess(update));
        }
         dispatch(handleListClassActivities(data.classId));
         dispatch(handleListClassQuizzes(data.classId));
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating class activity',
                error,
                module: 'CLASS_ACTIVITIES',
                operation: 'CREATE_CLASS_ACTIVITY'
            });
        }
        await dispatch(ClassActivityActions.createClassActivityFail(error));
    }
};

//  -- Create class activity ----------
export const handleCreateClassActivity = (data) => async (dispatch) => {
    await dispatch(ClassActivityActions.createClassActivity());

    try {
        data.scheduleAt =data.scheduleAt&&moment(data.scheduleAt).isValid()?data.scheduleAt: moment().toString()
        let dataClassActivity = omit(data, ['studentsSelected', 'dueDateDif', 'retakesDif']);
        alignActivityPayloadCurrentClassDueDate(dataClassActivity, data.dueDate, data.classId);
        if (dataClassActivity.classes && dataClassActivity.classes.length > 0) {
            dataClassActivity.classes = dataClassActivity.classes.map(cls => ({ ...cls, users:cls.users?cls.users:[]}))
        }
        if (Array.isArray(dataClassActivity.selectedAssignments)) {
            dataClassActivity.selectedAssignments = dataClassActivity.selectedAssignments.map((sa) => {
                if (!sa?.classes?.length) return sa;
                return {
                    ...sa,
                    classes: sa.classes.map((cls) => ({ ...cls, users: cls.users ? cls.users : [] })),
                };
            });
        }
        const diffActivity = [];
        let dataSS = data.studentsSelected;
        if (Array.isArray(dataSS)) {
            dataSS.forEach(student => {
                diffActivity.push({
                    classId: data.classId,
                    type: 'activity',
                    exerciseId: data.activityId,
                    userId: student.studentId,
                    dueDate: data.dueDateDif?data.dueDateDif:data.dueDate,
                    retakes: data.retakesDif?data.retakesDif:data.retakes,
                    displayName: data.displayName,
                    scheduleAt: data.scheduleAtDiff ? data.scheduleAtDiff: data.scheduleAt ,
                    lateDate: data.lateDate,
                })
            })
        }
        const clsAct = await apis.post('classActivitiesRDS', `/classActivitiesDiff`, {
            body: { activity: dataClassActivity, diff: diffActivity  }
        });
        if (clsAct && !clsAct.error) {
            const update = {
                ...clsAct.activity.filter(act => act.classId == data.classId)[0],
                diff:get(clsAct,"diff",[]),
                data: omit(dataClassActivity, ['activityId', 'classId', 'dueData'])
            };
            await dispatch(ClassActivityActions.createClassActivitySuccess(update));
        }
        if (dataClassActivity?.classId && dataClassActivity?.activity_type == 'graphic_organizer') {
            dispatch(handleListClassActivities(dataClassActivity?.classId));
        }

    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating class activity',
                error,
                module: 'CLASS_ACTIVITIES',
                operation: 'CREATE_CLASS_ACTIVITY'
            });
        }
        await dispatch(ClassActivityActions.createClassActivityFail(error));
    }
};

//  -- Delete class activity ----------
export const handleDeleteClassActivity = (activityID, classId) => async (dispatch) => {
    if (!activityID) return;
    await dispatch(ClassActivityActions.deleteClassActivity());

    try {
        await apis.del('classActivitiesRDS', `/classActivitiesDiff/${activityID}?classId=${classId}`);

        await dispatch(ClassActivityActions.deleteClassActivitySuccess({ id: activityID }));
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting class activity',
                error,
                module: 'CLASS_ACTIVITIES',
                operation: 'DELETE_CLASS_ACTIVITY'
            });
        }
        await dispatch(ClassActivityActions.deleteClassActivityFail(error));
    }
};

export const handleDeleteClassActivityForClasses = (activityID, classIds, currentClassId) => async (dispatch) => {
    if (!activityID || !Array.isArray(classIds) || classIds.length === 0) return;
    await dispatch(ClassActivityActions.deleteClassActivity());
    try {
        await apis.del('classActivitiesRDS', `/classActivitiesDiff/${activityID}`, {
            body: { classId: classIds }
        });
        const checkClassId = classIds.includes(currentClassId)
        await dispatch(ClassActivityActions.deleteMultiClassActivitySuccess({ id: activityID, checkClassId: checkClassId, classIds: classIds }));
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting class activity for classes',
                error,
                module: 'CLASS_ACTIVITIES',
                operation: 'DELETE_CLASS_ACTIVITY'
            });
        }
        await dispatch(ClassActivityActions.deleteClassActivityFail(error));
    }
};

//  -- List class activities ----------
export const handleListClassActivities = (classID) => async (dispatch) => {
    if (!classID) return;
    await dispatch(ClassActivityActions.listClassActivities());

    try {
        let activityData = [];
        const activitiesRDS = await apis.get('classActivitiesRDS', `/classActivitiesData/${classID}`);
        if (Array.isArray(activitiesRDS) && activitiesRDS.length > 0) {
            activityData = activitiesRDS;
        }
        await dispatch(ClassActivityActions.listClassActivitiesSuccess(activityData));
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing class activities',
                error,
                module: 'CLASS_ACTIVITIES',
                operation: 'LIST_CLASS_ACTIVITY'
            });
        }
        await dispatch(ClassActivityActions.listClassActivitiesFail(error));
    }
};

export const handleListClassActivitiesForStudent = (classId,userId) => async (dispatch) => {
    if (!classId) return;
    await dispatch(ClassActivityActions.listClassActivities());

    try {
        await dispatch(setLoadQuizAndClassActivity({classActivity: false}))
        let activityData = [];
        const activitiesRDS = await apis.get('classActivitiesRDS', `/classActivityDataStudent/${classId}/${userId}`);
        if (Array.isArray(activitiesRDS) && activitiesRDS.length > 0) {
            activityData = activitiesRDS;
        }
        await dispatch(ClassActivityActions.listClassActivitiesSuccess(activityData));
        await dispatch(setLoadQuizAndClassActivity({classActivity: true}))
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing class activities for student',
                error,
                module: 'CLASS_ACTIVITIES',
                operation: 'LIST_CLASS_ACTIVITY_FEEDBACK_STUDENT'
            });
        }
        await dispatch(ClassActivityActions.listClassActivitiesFail(error));
        await dispatch(setLoadQuizAndClassActivity({classActivity: false}))
    }
};

//  -- Update class activity ----------
export const handleGraphicOrgCustomActivityUpdate = (data) => async (dispatch) => {
    try {
        await apis.post('classActivitiesRDS', `/updateOwnGraphicOrg`, { body: data });
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error updating graphic org custom activity',
                error,
                module: 'CLASS_ACTIVITIES',
                operation: 'UPDATE_GRAPHIC_ORG_CUSTOM_ACTIVITY'
            })
        }
    }
};

//  -- Update class activity ----------
export const handleUpdateClassActivity = (activityID, data, updateTOAllClass, linkedSectionClassIds) => async (dispatch) => {
    try {
        let body = {
            activityID,
            activity: data,
            updateTOAllClass,
            linkedSectionClassIds: linkedSectionClassIds ?? undefined
        }
        await apis.put('classActivitiesRDS', `/classActivitiesDiff`, { body });
        await dispatch(ClassActivityActions.updateClassActivitySuccess({ id: activityID, ...data }));
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating class activity',
                error,
                module: 'CLASS_ACTIVITIES',
                operation: 'UPDATE_CLASS_ACTIVITY'
            });
        }
        await dispatch(ClassActivityActions.updateClassActivityFail(error));
    }
};
export const handleChangeStatusActivity = (activityID, active) => async (dispatch, getState) => {
    if (!activityID) return;
    try {
        const statusData = await apis.put('classActivitiesRDS', `/changeStatus`, {
            body: {
                id: activityID,
                active: active
            }
        });
        if (statusData) {
            await dispatch(ClassActivityActions.updateClassActivitySuccess({ id: activityID, ...statusData }));
        }
        const state = getState();
        const classId = state.currentClass?.id;
        const list = state.classActivities ?? [];
        const row =
            find(list, (x) => String(x.id) === String(activityID)) ||
            find(list, (x) => String(x.activityId) === String(activityID));
        const contentId = row?.activityId ?? get(row, 'data.id');
        if (classId && contentId) {
            await syncAssignmentStatusToFirestore({ classId, kind: 'activity', contentId, active });
        }
        return statusData;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'changing status activity',
                error,
                module: 'CLASS_ACTIVITIES',
                operation: 'CREATE_STORY_AI'
            });
        }
    }
};
export const handleHiddenStatusActivity = (is_hidden, id, type) => async (dispatch) => {
    if (!id) return;
    try {
        const statusData = await apis.post('classActivitiesRDS', `/hide_activity`, {
            body: {
                is_hidden, id, type
            }
        });
        if(statusData&&statusData.success&&statusData.data&&statusData.data.id){
            if(type === "activity"){
                await dispatch(ClassActivityActions.updateClassActivitySuccess(statusData.data));
            } else if(type === "quiz"){
                await dispatch(ClassQuizAction.updateClassQuizSuccess(statusData.data));
            } else if(type === "game"){
                await dispatch(ClassGameAction.updateClassGameActivity(statusData.data));
            }
        }
        return statusData;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in operation',
                error,
                module: 'CLASS_ACTIVITIES',
                operation: 'CREATE_CLASS_ACTIVITY'
            })
        }
    }
};

export const handleDeactivateByUser = (payload) => async (dispatch) => {
    if (!payload) return;
    try {
        const statusData = await apis.post('classActivitiesRDS', `/deactivateStudent`, {
            body:payload
        });
        if (statusData) {
            const reduxPayload = {
                assignmentId: payload?.id,
                deactivateStudent:  statusData?.deactivated_student
            }
            await dispatch(ClassActivityActions.createDeactivateByStudent(reduxPayload));
        }
        return statusData;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deactivating by user',
                error,
                module: 'CLASS_ACTIVITIES',
                operation: 'DELETE_BOOK_USER'
            });
        }
    }
};

export const handleReorderGradebookAssignments = (classId, orderedKeys) => async (dispatch) => {
    if (!classId || !Array.isArray(orderedKeys) || orderedKeys.length === 0) return null;
    try {
        const assignments = orderedKeys.map((assignmentKey, index) => ({
            assignmentKey,
            sequence: index + 1
        }));
      const {data = []} =  await apis.post('classActivitiesRDS', `/gradebook/reorder-assignments`, {
            body: {
                classId,
                assignments
            }
        });
        if(data?.length > 0){
            data.forEach(item => {
                if(item.activityId && item?.type !== 'worksheet'){
                    dispatch(ClassActivityActions.updateClassActivitiesById(item));
                } else if(item.quizId){
                    dispatch(ClassQuizAction.updateClassQuizById(item));
                } else if(item?.type === 'worksheet'){
                    dispatch(ClassGameAction.updateClassGameActivity(item));
                }
            });
        }
        return data?.length > 0 ? data : null;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'reordering gradebook assignments',
                error,
                module: 'CLASS_ACTIVITIES',
                operation: 'REORDER_GRADEBOOK_ASSIGNMENTS'
            });
        }
        throw error;
    }
};

export const handleListActivityOrQuizData = (id,classId) => async (dispatch) => {
    if (!id) return;

    try {
        const response = await apis.get('classActivitiesRDS', `/classActivitiesOrQuizzes/${id}?classId=${classId||null}`);
       if(response && response.success && response.data){
        const data = response.data;
        if(data.activityId){
            await dispatch(ClassActivityActions.updateClassActivitiesById(data));
        } else if(data.quizId){
            await dispatch(ClassQuizAction.updateClassQuizById(data));
        }
       }
       return response;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing class activities or quizzes',
                error,
                module: 'CLASS_ACTIVITIES',
                operation: 'LIST_CLASS_ACTIVITY_OR_QUIZ'
            });
        }
        await dispatch(ClassActivityActions.listClassActivitiesFail(error));
    }
};


export const handleListClassActivitiesForStudentWithIds = (classId,userId, ids = []) => async (dispatch) => {
    if (!classId) return;
    await dispatch(ClassActivityActions.listClassActivities());

    try {
        await dispatch(setLoadQuizAndClassActivity({classActivity: false}))
        let activityData = [];
        const activitiesRDS = await apis.post('classActivitiesRDS', `/classActivityDataStudentWithIds`, {
            body: {
                classId,
                userId,
                activityIds: ids
            }
        });
        if (Array.isArray(activitiesRDS) && activitiesRDS.length > 0) {
            activityData = activitiesRDS;
        }
        if(activityData?.length > 0){
            activityData.forEach(item => {
                if(item?.activityId){
                    dispatch(ClassActivityActions.listClassActivitiesForStudentWithIds(item));
                }
            })
        }else{
            dispatch(ClassActivityActions.listClassActivitiesForStudentWithIds({activityIds: ids, isDeleted: true}));
        }

        await dispatch(setLoadQuizAndClassActivity({classActivity: true}))
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing class activities for student',
                error,
                module: 'CLASS_ACTIVITIES',
                operation: 'LIST_CLASS_ACTIVITY_FEEDBACK_STUDENT'
            });
        }
        await dispatch(ClassActivityActions.listClassActivitiesFail(error));
        await dispatch(setLoadQuizAndClassActivity({classActivity: false}))
    }
};